import type { ReactNode } from 'react';

export interface FigureProps {
  /** root-relative (/blog/...) or absolute image URL */
  src: string;
  alt: string;
  caption?: ReactNode;
  /** intrinsic width/height help the browser reserve space (avoids CLS) */
  width?: number;
  height?: number;
}

/** An image with optional caption, styled for the reading column. */
export const Figure = ({ src, alt, caption, width, height }: FigureProps) => (
  <figure className="my-6">
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      className="w-full rounded-10 border border-line"
    />
    {caption ? (
      <figcaption className="mt-2 text-center text-13 text-text-3">{caption}</figcaption>
    ) : null}
  </figure>
);
